import React from 'react';


const Footer = (props: {
  year: number
}) => (
  <React.Fragment>
    <div className='modus-footer'>
      Copyright © {props.year} Trimble Inc.
    </div>
  </React.Fragment>
)

export default Footer;